export enum ModuleEnum {
  ACCESS_CONTROL_MANAGER = 'ACCESS_CONTROL_MANAGER',
  ACTIVITY_MANAGER = 'ACTIVITY_MANAGER',
  DATA_CONTROL_MANAGER = 'DATA_CONTROL_MANAGER',
  EVENT_MANAGER = 'EVENT_MANAGER',
  MOBILITY_ACCOUNT_MANAGER = 'MOBILITY_ACCOUNT_MANAGER',
  MOBILITY_ENGINE = 'MOBILITY_ENGINE',
  INVOICING_MANAGER = 'INVOICING_MANAGER',
  SUBSCRIPTION_MANAGER = 'SUBSCRIPTION_MANAGER',
  USER_MANAGER = 'USER_MANAGER',
  WORKFLOW_MANAGER = 'WORKFLOW_MANAGER'
}